import { Col, Divider, Form, Modal, Row, Skeleton, Typography } from "antd";
import { registerUser } from "apps/Account/Services";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaCheckbox } from "apps/Common/MazakaCheckbox";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaInput } from "apps/Common/MazakaInput";
import { MazakaPassword } from "apps/Common/MazakaPassword";
import useMazakaForm from "hooks/useMazakaForm";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ConfirmLoginCode from "../ConfirmCode/ConfirmCode";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import GeneralPhoneNumber2 from "apps/Common/GeneralPhoneNumber2";
import { useGetContractByType } from "apps/CustomerPanel/Ad/ServerSideStates";
import SubscriptionAgreement from "./Components/SubscriptionAgreements";

const Register = (props: any) => {
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
  const [isShowConfirmCode, setIsShowConfirmCode] = useState(false);
  const [isResetPassValidation, setIsResetPassValidtion] =
    useState<boolean>(false);
  const [phoneNumber, setPhoneNumber] = useState({
    numberPrefix: "",
    numberBody: "",
  });
  const contract = useGetContractByType("1");
  const [isShowAgreementModal, setIsShowAgreement] = useState(false);

  const handleOnFinish = async () => {
    mazakaForm.setLoading();
    let formValues = form.getFieldsValue();
    let split_number = formValues["Phone"].split("+");
    let numberPrefix = split_number[0];
    let numberBody = split_number[1];
    let acceptedConstratList = [contract?.data?.data.id];

    const data = {
      ...formValues,
      numberPrefix,
      numberBody,
      selectedContract: acceptedConstratList,
      userType: 1,
    };
    delete data["Phone"];
    delete data["generalConditions"];
    delete data[contract?.data?.data?.name];

    try {
      const response: any = await registerUser(data);
      mazakaForm.setSuccess(1000, () => "Kayıt olma işlemi Başarılı");
      openNotificationWithIcon("default", response?.message || "");
      await setPhoneNumber({
        numberPrefix,
        numberBody,
      });
      setIsShowConfirmCode(true);
      form.resetFields();
      setIsResetPassValidtion(true);
    } catch (error: any) {
      mazakaForm.setFailed(
        2000,
        error?.message || "Bilinmeyen bir hata oluştu"
      );
      openNotificationWithIcon("default", error?.message || "");

      console.log("Somethings wrong during login to dashboard", error);
    }
  };
  const { Text } = Typography;
  const [isChecked, setIsChecked] = useState(false);

  return (
    <>
      {isShowConfirmCode ? (
        <>
          <ConfirmLoginCode
            setIsShowConfirmCode={setIsShowConfirmCode}
            numberPrefix={phoneNumber.numberPrefix}
            numberBody={phoneNumber.numberBody}
            onFinish={props.onFinish}
            pageType= "register"
          />
        </>
      ) : (
        <>
          <Col span={24}>
            <MazakaForm
              submitButtonVisible={false}
              form={form}
              onFinish={handleOnFinish}
            >
              <Row gutter={[10, 10]} className="!px-4">
                <MazakaInput
                  xs={24}
                  lg={12}
                  name={"name"}
                  label={"Adı"}
                  className="!m-0"
                  inputClassName="!bg-[#f7f7f7] !p-2"
                  rules={[{ required: true, message: "Adı Zorunlu" }]}
                  placeholder={"Adı"}
                />
                <MazakaInput
                  xs={24}
                  lg={12}
                  name={"surname"}
                  label={"Soyadı"}
                  className="!m-0"
                  inputClassName="!bg-[#f7f7f7] !p-2"
                  rules={[{ required: true, message: "Soyadı Zorunlu" }]}
                  placeholder={"Soyadı"}
                />
                <MazakaInput
                  xs={24}
                  name={"email"}
                  label={"E-Posta"}
                  className="!m-0"
                  inputClassName="!bg-[#f7f7f7] !p-2"
                  rules={[
                    {
                      type: "email",
                      message: "E-Posta Formatı Geçersiz",
                    },
                    { required: true, message: "E-Posta Zorunlu" },
                  ]}
                  placeholder={"E-Posta"}
                />

                <GeneralPhoneNumber2
                  label={"Gsm Numaranız"}
                  name="Phone"
                  required={true}
                  xs={24}
                  form={form}
                  placeholder={"Gsm Numaranız"}
                  inputClass="!m-0 !bg-[#f7f7f7] !h-[39px] !text-black"
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                  ]}
                />
                <Col span={24}>
                  <Row gutter={[10, 20]}>
                    <MazakaPassword
                      isResetPassValidation={isResetPassValidation}
                      setIsResetPassValidation={setIsResetPassValidtion}
                      isShowDescriptionPass={true}
                      label={"Şifre"}
                      inputClassName="!bg-[#f7f7f7] !p-2"
                      name={"password"}
                      rules={[{ required: true, message: "" }]}
                      placeholder={"Şifre"}
                      className="!m-0"
                      span={24}
                    />
                  </Row>
                </Col>
                <>
                  <Skeleton loading={contract.isLoading || contract.isFetching}>
                    {contract?.data?.data && (
                      <MazakaCheckbox
                        rules={[{ required: true, message: "" }]}
                        name={contract?.data?.data?.name}
                        text={
                          <Text className="!text-[#606060]">
                            <Text
                              className="!text-[#1878ff] !cursor-pointer"
                              onClick={() => {
                                setIsShowAgreement(true);
                              }}
                            >
                              {contract?.data?.data?.title || ""}
                            </Text>
                            <span
                              
                            >
                              &nbsp;
                              kabul ediyorum
                            </span>
                          </Text>
                        }
                      />
                    )}
                  </Skeleton>
                </>
                <MazakaCheckbox
                  rules={[{ required: true, message: "" }]}
                  name={"generalConditions"}
                  text={
                    <Text className="text-[#606060]">
                      İletişim bilgilerime kampanya, tanıtım ve reklam
                      içeriklerine ilişkin ticari elektronik ileti
                      gönderilmesine, kişisel verilerimin bu amaçla işlenmesine
                      ve tedarikçilerinizle paylaşılmasına izin veriyorum.
                    </Text>
                  }
                />

                <Col span={24}>
                  <MazakaButton
                    className="!p-4 !bg-[#FFC502] !text-black"
                    htmlType="submit"
                    block
                    processType={formActions.submitProcessType}
                  >
                    Kayıt Ol
                  </MazakaButton>
                </Col>
                <Col span={24}>
                  <Divider className="!m-0" />
                </Col>
              </Row>
            </MazakaForm>
          </Col>
        </>
      )}
      <Modal
        open={isShowAgreementModal}
        onCancel={() => {
          setIsShowAgreement(false);
        }}
        width={"80%"}
        footer={false}
      >
        <SubscriptionAgreement containerClassNames={"!px-4"} />
      </Modal>
    </>
  );
};

export default Register;
